



export const BASE_URL: string | null = document.getElementsByTagName('base')[0].getAttribute('href');